import { useMemo } from "react";
import { postTarget } from "../../hooks/useCommentsStore";
import CommentsSection, { FULL_PERMISSIONS, READ_ONLY_PERMISSIONS } from "./CommentsSection";

// Comments for one post (CommentsSection with a post target).
//
// `readOnly` is true for expired posts (including ones that expire while open):
// existing comments and counts stay visible, every mutation control is hidden.
export default function PostComments({
  post,
  readOnly,
  focusedCommentId,
  onOpenConversation,
  onCloseConversation,
  onCommentCountChange,
}) {
  const target = useMemo(() => postTarget(post.id), [post.id]);

  return (
    <CommentsSection
      target={target}
      permissions={readOnly ? READ_ONLY_PERMISSIONS : FULL_PERMISSIONS}
      disabledMessage="Expired posts are read-only."
      focusedCommentId={focusedCommentId}
      onOpenConversation={onOpenConversation}
      onCloseConversation={onCloseConversation}
      onCommentCountChange={onCommentCountChange}
    />
  );
}
